/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetMissingTranslationsRequest,
  GetMissingTranslationsResponse,
} from '../models/index';
import {
    GetMissingTranslationsRequestFromJSON,
    GetMissingTranslationsRequestToJSON,
    GetMissingTranslationsResponseFromJSON,
    GetMissingTranslationsResponseToJSON,
} from '../models/index';

export interface ApiTranslationGetMissingTranslationsPostRequest {
    getMissingTranslationsRequest?: GetMissingTranslationsRequest;
}

/**
 * 
 */
export class TranslationApi extends runtime.BaseAPI {

    /**
     */
    async apiTranslationGetMissingTranslationsPostRaw(requestParameters: ApiTranslationGetMissingTranslationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMissingTranslationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Translation/GetMissingTranslations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMissingTranslationsRequestToJSON(requestParameters['getMissingTranslationsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMissingTranslationsResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTranslationGetMissingTranslationsPost(requestParameters: ApiTranslationGetMissingTranslationsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMissingTranslationsResponse> {
        const response = await this.apiTranslationGetMissingTranslationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
